import { CurrencyModel } from "../management/currency.model";

export class ProviderModel {
  providerId: number = 0;
  companyId: number = 0;
  typeDocumentId: number = 0;
  document: string = '';
  digitVerification: number = 0;
  typePersonId: number = 0;
  names: string | null = null;
  lastNames: string | null = null;
  businessName: string = '';
  comercialName: string | null = null;
  active: boolean = true;
  address: string = '';
  email: string | null = null;
  phone: string = '';
  alterPhone: string | null = null;
  departmentId: number = 0;
  cityId: number = 0;
  observation: string | null = null;
  shopping: boolean = false;
  subRent: boolean = false;
  transport: boolean = false;
  rateDiscount: number = 0;
  swSimpleTaxRegime: boolean = false;
  swIvaResponsible: boolean = false;
  swGreatContributor: boolean = false;
  swIvaRetainer: boolean = false;
  swDeclarant: boolean = false;
  swSelfRetainer: boolean = false;
  swExpirationDays: boolean = false;
  expirationDays: number = 0;
  currencyId: number = 0;
  currency: CurrencyModel | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
